import { Route, Routes, Outlet, Link } from "react-router-dom";
import { DashboardLayout, PublicLayout } from "./components/layouts";
import { AuthPage, PasswordRecoveryPage, VerifyEmailPage } from "./pages/AuthPages";
import { DonationPage } from "./pages/DonationPage";
import { OverlayPage } from "./pages/OverlayPage";
import { ApiDocsPage, DevelopersPage, DocsPage, FeaturesPage, HomePage, LegalPage, PricingPage, StatusPage } from "./pages/PublicPages";
import { CampaignsPage, OverviewPage, PaymentsPage } from "./pages/dashboard/CorePages";
import { ApplicationsPage, ApiKeysPage, IntegrationHubPage, PaymentProfilesPage } from "./pages/dashboard/ApiManagementPages";
import { AdminPage, AssetsPage, AuditPage, DevelopersDashboardPage, DonationsPage, LogsPage, OverlayEditorPage, OverlaysPage, OverlayTestPage, QrPage, SettingsPage, TeamPage, WebhooksPage } from "./pages/dashboard/OpsPages";
import { AdminMembershipPage, MembershipPage } from "./pages/dashboard/MembershipPages";

function DashboardRoute() { return <DashboardLayout><Outlet /></DashboardLayout>; }

export default function App() {
  return <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/features" element={<FeaturesPage />} />
    <Route path="/pricing" element={<PricingPage />} />
    <Route path="/developers" element={<DevelopersPage />} />
    <Route path="/docs" element={<DocsPage />} />
    <Route path="/docs/api" element={<ApiDocsPage />} />
    <Route path="/status" element={<StatusPage />} />
    <Route path="/login" element={<AuthPage mode="login" />} />
    <Route path="/register" element={<AuthPage mode="register" />} />
    <Route path="/verify-email" element={<VerifyEmailPage />} />
    <Route path="/forgot-password" element={<PasswordRecoveryPage />} />
    <Route path="/reset-password" element={<PasswordRecoveryPage />} />
    <Route path="/privacy" element={<LegalPage type="privacy" />} />
    <Route path="/terms" element={<LegalPage type="terms" />} />
    <Route path="/payment-limitations" element={<LegalPage type="limitations" />} />
    <Route path="/donate/:slug" element={<DonationPage />} />
    <Route path="/o/:token" element={<OverlayPage />} />
    <Route element={<DashboardRoute />}>
      <Route path="/dashboard" element={<OverviewPage />} />
      <Route path="/dashboard/applications" element={<ApplicationsPage />} />
      <Route path="/dashboard/api-keys" element={<ApiKeysPage />} />
      <Route path="/dashboard/payment-profiles" element={<PaymentProfilesPage />} />
      <Route path="/dashboard/integration" element={<IntegrationHubPage />} />
      <Route path="/dashboard/qr" element={<QrPage />} />
      <Route path="/dashboard/payments" element={<PaymentsPage />} />
      <Route path="/dashboard/developers" element={<DevelopersDashboardPage />} />
      <Route path="/dashboard/logs" element={<LogsPage />} />
      <Route path="/dashboard/webhooks" element={<WebhooksPage />} />
      <Route path="/dashboard/campaigns" element={<CampaignsPage />} />
      <Route path="/dashboard/donations" element={<DonationsPage />} />
      <Route path="/dashboard/overlays" element={<OverlaysPage />} />
      <Route path="/dashboard/overlays/:id/edit" element={<OverlayEditorPage />} />
      <Route path="/dashboard/overlays/:id/test" element={<OverlayTestPage />} />
      <Route path="/dashboard/assets" element={<AssetsPage />} />
      <Route path="/dashboard/team" element={<TeamPage />} />
      <Route path="/dashboard/audit" element={<AuditPage />} />
      <Route path="/dashboard/settings" element={<SettingsPage />} />
      <Route path="/dashboard/membership" element={<MembershipPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/memberships" element={<AdminMembershipPage />} />
    </Route>
    <Route path="*" element={<PublicLayout><div className="not-found"><strong>404</strong><h1>ไม่พบหน้าที่คุณต้องการ</h1><p>URL อาจถูกเปลี่ยนหรือถูก revoke แล้ว</p><Link className="button button-primary" to="/">กลับหน้าแรก</Link></div></PublicLayout>} />
  </Routes>;
}
